export default async function InsertClientdata(clientId,Name,PhoneNumber,HandlingBy) {
    let url = window.RealestateService + `/api/LeadData/InsertClientData?ClientId=${clientId}&Name=${Name}&phoneNumber=${PhoneNumber}&handlingby=${HandlingBy}`
    let response = {}

    let head = {
        "Content-Type": "application/json",
        'accept': '*/*'
    }
    response = await fetch(url, {
        method: "POST",
        headers: head,
        // body: JSON.stringify(senddata)
    }).then(res => res.json()).then(response)
    return response;
}